module.exports = __webpack_public_path__ + "img/Apoint5.5759635d.png";